/* eslint-disable import/prefer-default-export */

export function pageview(url: string) {
  if (!process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS) return;

  (window as any).gtag("config", process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
    page_path: url,
  });
}
